// extracted by mini-css-extract-plugin
module.exports = {"root":"CurrencySelector_root__1GmD7","long":"CurrencySelector_long__MtXsY","short":"CurrencySelector_short__GkG0y"};